import './style.scss';

export function careers_hero_block() {
    const block = document.querySelector('.careers_hero_block');
    if (!block) return;

}
